export default __webpack_public_path__ + "static/media/logo-ictus.2d6c36d7.jpg";